import React, { useEffect, useState } from 'react';
import { neonQuery } from '../services/api';

// Email and text-list status for one customer, live from Dotdigital (lib/contact-channels.js).
// Customer Search and Customer Analysis. Texts are checked by every phone tied to the person,
// so "Texts: subscribed" names the number that is on the list.

const EMAIL = {
  subscribed: ['Subscribed', 'good'],
  unsubscribed: ['Unsubscribed', 'bad'],
  none: ['Not on the list', 'mut'],
  unknown: ['Could not check', 'mut'],
};
const SMS = {
  subscribed: ['Subscribed', 'good'],
  unsubscribed: ['Opted out', 'bad'],
  none: ['Not signed up', 'mut'],
  unknown: ['Could not check', 'mut'],
};
const COLORS = {
  light: { good: ['#e6f4ea', '#1e7b3c'], bad: ['#fdeee8', '#a33a14'], mut: ['#eef1f4', '#5b6b78'] },
  dark: { good: ['rgba(255,255,255,.16)', '#bff0cf'], bad: ['rgba(255,255,255,.16)', '#ffc9b5'], mut: ['rgba(255,255,255,.12)', '#d6e2ea'] },
};

function Pill({ label, text, tone, theme, title }) {
  const [bg, fg] = COLORS[theme][tone];
  return (
    <span title={title} style={{ display: 'inline-block', background: bg, color: fg, borderRadius: 10, padding: '2px 9px', fontSize: 11, fontWeight: 700, marginRight: 6, whiteSpace: 'nowrap' }}>
      {label}: {text}
    </span>
  );
}

export default function ListStatus({ contactIds, email, theme = 'light', style }) {
  const [st, setSt] = useState(undefined);
  const key = JSON.stringify([contactIds, email]);
  useEffect(() => {
    let live = true;
    setSt(undefined);
    neonQuery('customer_channels', { contactIds, email })
      .then((r) => { if (live) setSt(r || null); })
      .catch(() => { if (live) setSt(null); });
    return () => { live = false; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps

  if (st === undefined) {
    return <div style={{ fontSize: 11, opacity: 0.7, ...style }}>Checking email and text lists...</div>;
  }
  const e = (st && st.email) || { status: 'unknown' };
  const s = (st && st.sms) || { status: 'unknown' };
  const [et, etone] = EMAIL[e.status] || EMAIL.unknown;
  const [stt, stone] = SMS[s.status] || SMS.unknown;
  const emailText = e.status === 'unsubscribed' && e.raw && e.raw !== 'unsubscribed' ? `${et} (${e.raw})` : et;
  return (
    <div style={style}>
      <Pill theme={theme} label="Email" text={emailText} tone={etone} title="Dotdigital, by this email address" />
      <Pill theme={theme} label="Texts" text={s.phone ? `${stt} ${s.phone}` : stt} tone={stone}
        title={`Dotdigital, by phone: ${s.checked || 0} number${s.checked === 1 ? '' : 's'} tied to this customer checked`} />
    </div>
  );
}
